import React from 'react';
import { TaxRescuePage } from './pages/TaxRescuePage';
export function App() {
  return <TaxRescuePage data-id="element-0" />;
}